import * as React from 'react'
import classnames from 'classnames'

import cls from './Widget.module.scss'

const UikWidget = ({ children, className, Component, padding, margin, isHidden, ...rest }) => (
  <Component
    className={classnames(cls.wrapper, className, {
      [cls.padding]: padding,
      [cls.margin]: margin,
      [cls.hidden]: isHidden,
    })}
    {...rest}
  >
    {children}
  </Component>
)

UikWidget.defaultProps = {
  className: null,
  children: null,
  padding: false,
  margin: false,
  Component: 'div',
  isHidden: false,
}

export default UikWidget
